import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "input", "preview", "previewContainer", "removeBtn"]
  static values = { apiKey: String }

  connect() {
    if (!window.filestack && this.hasApiKeyValue) {
      this.loadFilestackScript()
    }
  }

  loadFilestackScript() {
    const script = document.createElement("script")
    script.src = "https://static.filestackapi.com/filestack-js/3.x.x/filestack.min.js"
    script.async = true
    document.head.appendChild(script)
  }

  open() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  openFilePicker() {
    if (!window.filestack) {
      alert("Filestack is loading, please try again.")
      return
    }

    const client = filestack.init(this.apiKeyValue)
    const options = {
      accept: ["image/*"],
      maxFiles: 1,
      transformations: {
        crop: { aspectRatio: 16 / 9 }
      },
      onUploadDone: (result) => {
        if (result.filesUploaded.length > 0) {
          const file = result.filesUploaded[0]
          this.inputTarget.value = file.url
          this.updatePreview(file.url)
        }
      }
    }

    client.picker(options).open()
  }

  updatePreview(url) {
    if (url) {
      this.previewTarget.src = url
      this.previewContainerTarget.classList.remove("hidden")
      this.removeBtnTarget.classList.remove("hidden")
    } else {
      this.previewContainerTarget.classList.add("hidden")
      this.removeBtnTarget.classList.add("hidden")
    }
  }

  removeBackground(event) {
    event.preventDefault()
    this.inputTarget.value = ""
    this.previewContainerTarget.classList.add("hidden")
    this.removeBtnTarget.classList.add("hidden")
  }
}
